<template>
  <SoDataTableServer
    :headers="headers"
    :data="tableData"
    :options="tableOptions"
    search-placeholder="Search by email / phone"
    searchable
    data-testId="freshdesk-contacts-table"
    @fetch="fetchData"
  >
    <template #itemActions="{ item }">
      <div class="d-flex gap-1 justify-end">
        <SoButton
          title="Freshdesk Tickets"
          data-testid="freshdesk-contacts-table-open-tickets-btn"
          class="ml-auto"
          @click="goToFreshdeskTicketsFeed(item.external_id)"
        />
      </div>
    </template>
  </SoDataTableServer>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDataTableServer, {
    SoDataTableOptions,
  } from "@/components/dataTable/SoDataTableServer.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { QueryResult } from "@/api/utils/types"
  import { SearchFreshdeskContactsQuery } from "@/api/hasura/generated/graphql"
  import { FreshdeskService } from "@/services/FreshdeskService"
  import { RouteNames } from "@/types/router"

  const headers: SoDataTableHeader[] = [
    {
      title: "External ID",
      key: "external_id",
      sortable: false,
    },
    {
      title: "Account Number",
      key: "account_number",
      fallbackValue: "-",
      sortable: false,
    },
    {
      title: "Email",
      key: "email",
      fallbackValue: "-",
      sortable: false,
    },
    {
      title: "Phone",
      key: "phone",
      fallbackValue: "-",
      sortable: false,
    },
    {
      title: "Mobile",
      key: "mobile",
      fallbackValue: "-",
      sortable: false,
    },
  ]

  export default defineComponent({
    components: {
      SoButton,
      SoDataTableServer,
    },
    data() {
      return {
        headers: headers,
        query: null as QueryResult<SearchFreshdeskContactsQuery> | null,
        tableOptions: {
          search: "" as string | null,
        } as Partial<SoDataTableOptions>,
        searchQueryParams: null as string | null,
      }
    },
    computed: {
      tableData() {
        return {
          isLoading: !!this.query?.isFetching,
          totalItems:
            this.query?.data?.freshdesk_contact_aggregate?.aggregate?.count ??
            0,
          items:
            this.query?.data?.freshdesk_contact?.map((contact) => ({
              ...contact,
              email: contact.raw_data.email,
              phone: contact.raw_data.phone,
              mobile: contact.raw_data.mobile,
            })) ?? [],
        }
      },
    },
    created() {
      this.tableOptions.search = (this.$route.query.search ?? "") as string
    },
    methods: {
      fetchData({ search, page, pageSize }: SoDataTableOptions) {
        this.$router.replace({
          query: {
            ...(search && { search }),
          },
        })

        this.query = FreshdeskService.searchLegacyContacts({
          offset: page - 1,
          limit: pageSize,
          search: `%${search}%`,
        })
      },
      goToFreshdeskTicketsFeed(contactId: string) {
        this.$router.push({
          name: RouteNames.AdminFreshdeskTickets,
          params: {
            contactId: contactId,
          },
        })
      },
    },
  })
</script>
